import PropTypes from 'prop-types';

const textAreaStyle = {
  fontFamily: 'Source Sans Pro',
  width: '100%',
  maxWidth: '600px',
  height: '200px',
  borderRadius: '6px',
  boxShadow: '0 0 10px 0 rgba(99, 140, 177, 0.1)',
  border: 'solid 1px rgba(46, 95, 202, 0.1)',
  backgroundColor: '#ffffff',
  outline: 'none',
  resize: 'none',
  padding: '10px',
};

function TextArea({
  label,
  required,
  value,
  onChange,
  onBlur,
  placeholder,
  type,
  error,
  afterText,
  maxLength,
  pattern,
}) {
  return (
    <div style={{ width: '100%' }}>
      <textarea
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        type={type}
        maxLength={maxLength}
        pattern={pattern}
        style={textAreaStyle}
      />
      {error && (
        <p className="onboarding-error" style={{ position: 'initial' }}>
          {error}
        </p>
      )}
    </div>
  );
}

TextArea.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  error: PropTypes.string,
  afterText: PropTypes.string,
  maxLength: PropTypes.number,
  pattern: PropTypes.string,
};

export default TextArea;
